<div class="experience-progress" #mainEl [ngClass]="{'loading': !isInit}">

  <div class="experience-progress__middle">
    <div class="experience-progress__middle-vertical-line"></div>
    <div class="experience-progress__middle-box" [ngClass]="{'gold': isLastMilestoneAchieved}">
      <div class="experience-progress__middle-box-title">{{"CLASS_DASHBOARD.CURRENT_INFORMATION.POINTS" | translate}}</div>
      <div class="experience-progress__middle-box-points">
        <brt-icon [icon]="'star'" [add-blur]="true"></brt-icon>
        <div class="experience-progress__middle-box-points-number">{{uiCurrentExperience | number:"."}}</div>
      </div>
      <div class="experience-progress__middle-box-milestones">{{ achievedMilestones }} von {{totalMilestones}} {{"CLASS_DASHBOARD.CURRENT_INFORMATION.MILESTONE" | translate}}</div>
    </div>
  </div>
  <div class="experience-progress__progress-row-wrapper">
    <div class="experience-progress__progress-row">
      <div class="experience-progress__progress-bar-common">
        <div class="experience-progress__progress-bar-common-fill"></div>
      </div>

      <div class="experience-progress__milestone" [ngClass]="{'blocked': isMilestoneBlocked(milestone)}" *ngFor="let milestone of milestones">

        <div class="experience-progress__milestone-data">
          <div class="experience-progress__milestone-icon" [ngClass]="['icon-' + milestone.sequenceFolder]">

            <img [src]="'/assets/game-dashboard-icons/milestones/' + milestone.iconName" [alt]="milestone.name" *ngIf="isMilestoneBlocked(milestone) || !milestoneHasSequenceAnimation(milestone); else animWrapper">

            <ng-template #animWrapper>
              <div class="experience-progress__milestone-animation">
<!--                <canvas #milestoneSequenceCanvas [attr.data-milestone-id]="milestone.id"></canvas>-->
                <brt-lottie [lottieOptions]="{path: '/assets/game-dashboard-icons/milestones/sequence/' + milestone.sequenceFolder + '/' + milestone.sequenceFolder + '.json', autoplay: false, loop: false}"
                (instanceCreated)="onMilestoneAnimCreated($event)"></brt-lottie>
              </div>
            </ng-template>

          </div>
          <div class="experience-progress__milestone-title">{{milestone.name}}</div>
          <div class="experience-progress__milestone-points">{{milestone.points | number:'.'}} {{"CLASS_DASHBOARD.POINTS_DIAMONDS" | translate}}</div>
        </div>
        <div class="experience-progress__milestone-bar">
          <div class="experience-progress__milestone-bar-progress-wide">
            <div class="experience-progress__milestone-bar-progress"></div>
          </div>
        </div>
      </div>

      <div class="experience-progress__milestone experience-progress__milestone--last">
        <div class="experience-progress__milestone-bar">
          <div class="experience-progress__milestone-bar-progress-wide">
            <div class="experience-progress__milestone-bar-progress"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="experience-progress__loader">
    <img class="skeleton-desktop" src="/assets/img/Milestones-ITEM.svg" alt="">
    <img class="skeleton-mobile" src="/assets/img/Milestones-mobile-ITEM.svg" alt="">
  </div>


</div>
